import { EventBus } from "../../services/eventbus";

const errorHelper = {
  showError(err) {
    let msg = {};
    // -- token Error
    if (
      err.data === "You do not have permission to view this directory or page."
    )
      msg.title =
        err.data + " If this error persists refresh page or logout then login.";
    else if (err.data) msg.title = err.data;
    else if (err.message) msg.title = err.message;
    else if (err.config) {
      // -- axios error
      msg.title = "Network Error";
      msg.text = `could not connect to ${err.config.url}`;
      msg.details = `Check your connection to the server    ${JSON.stringify(
        err.response
      )}`;
    } else if (err.response) {
      // -- http error
      msg.title = "API Exception";
      if (err.response.status) msg.code = `Error: ${err.response.status}`;
      if (err.response.data) msg.details = err.response.data.message;
    }

    EventBus.$emit("showglobaldialog", msg);
  }
};
export default errorHelper;
